var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-container"},[_c('gameOption'),_c('div',{staticClass:"navbar"},_vm._l((_vm.pages),function(p){return _c('div',{key:p.id,staticClass:"navbar-item",class:{ 'active': p.isActive },on:{"click":() => _vm.$router.push({ path: p.path, query: _vm.$route.query })}},[_c('p',[_vm._v(_vm._s(p.name))])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }